document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector("[data-lr-header]");
  if (header) {
    window.addEventListener("scroll", function () {
      header.style.boxShadow = window.scrollY > 40 ? "0 1px 0 rgba(60,42,30,0.1)" : "none";
    });
  }
  var mobileMenu = document.querySelector("[data-lr-mobile-menu]");
  var menuToggle = document.querySelector("[data-lr-menu-toggle]");
  var menuClose = document.querySelector("[data-lr-menu-close]");
  if (mobileMenu && menuToggle) menuToggle.addEventListener("click", function () { mobileMenu.classList.add("open"); });
  if (mobileMenu && menuClose) menuClose.addEventListener("click", function () { mobileMenu.classList.remove("open"); });
  if (mobileMenu) {
    mobileMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () { mobileMenu.classList.remove("open"); });
    });
  }
  var bagBtn = document.querySelector("[data-lr-bag-toggle]");
  var bagPanel = document.querySelector("[data-lr-bag-panel]");
  if (bagBtn && bagPanel) {
    bagBtn.addEventListener("click", function () { bagPanel.classList.toggle("open"); });
    document.addEventListener("click", function (e) {
      if (!bagPanel.contains(e.target) && !bagBtn.contains(e.target)) bagPanel.classList.remove("open");
    });
  }
  var revealEls = document.querySelectorAll(".lr-reveal");
  if (revealEls.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add("in");
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }
  document.querySelectorAll("[data-lr-toggle-group]").forEach(function (group) {
    var pills = group.querySelectorAll("[data-lr-toggle-pill]");
    var descTarget = group.parentElement.querySelector("[data-lr-toggle-desc]");
    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        pills.forEach(function (p) { p.classList.remove("active"); });
        pill.classList.add("active");
        if (descTarget) descTarget.textContent = pill.getAttribute("data-lr-toggle-desc-text") || "";
      });
    });
  });
  document.querySelectorAll("[data-lr-quick-add]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding...";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = "Added ✓";
          updateCartCount();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = "Try Again";
          btn.disabled = false;
        });
    });
  });
  function updateCartCount() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-lr-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      });
  }
  var productRoot = document.querySelector("[data-lr-product-root]");
  if (productRoot) {
    var variantScript = document.querySelector("[data-lr-product-variants]");
    var variants = [];
    if (variantScript) {
      try { variants = JSON.parse(variantScript.textContent); } catch (e) { variants = []; }
    }
    var optionGroups = productRoot.querySelectorAll(".lr-variant-group");
    var selected = [];
    optionGroups.forEach(function (group) {
      var activePill = group.querySelector(".lr-toggle-pill.active");
      selected.push(activePill ? activePill.getAttribute("data-lr-variant-value") : null);
    });
    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }
    function applyVariant() {
      var match = findVariant();
      var hiddenInput = productRoot.querySelector("[data-lr-variant-id]");
      var priceEl = productRoot.querySelector(".lr-product-page-price");
      var submitBtn = productRoot.querySelector("#lr-product-form button[type=submit]");
      if (match && hiddenInput) {
        hiddenInput.value = match.id;
        if (priceEl && match.price) {
          priceEl.childNodes[0].nodeValue = (match.price / 100).toLocaleString(undefined, { style: "currency", currency: "USD" }) + " ";
        }
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? "Add To Bag" : "Sold Out";
        }
      }
    }
    optionGroups.forEach(function (group, groupIndex) {
      group.querySelectorAll("[data-lr-variant-option]").forEach(function (pill) {
        pill.addEventListener("click", function () {
          group.querySelectorAll(".lr-toggle-pill").forEach(function (p) { p.classList.remove("active"); });
          pill.classList.add("active");
          selected[groupIndex] = pill.getAttribute("data-lr-variant-value");
          applyVariant();
        });
      });
    });
  }
});